import { Component, OnInit , ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-json-validator',
    templateUrl: './json-validator.component.html',
    styleUrls: ['./json-validator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JsonValidatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  vaidateJSON(jsonObj) {
    jsonObj = typeof jsonObj !== "string"
      ? JSON.stringify(jsonObj)
      : jsonObj;

    try {
      jsonObj = JSON.parse(jsonObj);
    } catch (e) {
      return false;
    }

    if (typeof jsonObj === "object" && jsonObj !== null) {
      return true;
    }
    return false;
  }

  noNegatives(event) {
    let txt = event.target.value;
    event.target.value = txt.replace('-', '');
    return event.target.value;
  }

  noNegativesDecimals(event) {
    let txt = event.target.value;
    event.target.value = txt.replace('-', '');
    event.target.value = txt.replace('e', '');
    event.target.value = event.target.value.replace('.', '');
    return event.target.value;
  }

  allowAlphaNumericSpecial(event) {
    let txt = event.target.value;
    if (!txt.match(/^[a-zA-Z0-9-_$][\sa-zA-Z0-9-_$]+$/)) {
      if (txt == ' ') { //only entered starting single space
        event.target.value = txt.replace(' ', '');
      }
      // else if (txt.match(/^\s[a-zA-Z0-9-_$][\sa-zA-Z0-9-_$]+$/)) {  //entered txt & then entered space in 1st character
      //   event.target.value = txt.substring(1, txt.length);
      // } 
      else {
        event.target.value = txt.replace(/[^a-zA-Z0-9-_$ ]/g, ''); //remove special chars other than -, _,$
      }
    } else {
      event.target.value = event.target.value.replace(/  +/g, ' '); //replace continuous multiple spaces with single space
    }
    return event.target.value;
  }

  allowAlphaNumeric(event) {  //accept space
    let txt = event.target.value;
    if (!txt.match(/^[a-zA-Z0-9][\sa-zA-Z0-9]+$/)) {
      if (txt == ' ') { //only entered starting single space
        event.target.value = txt.replace(' ', '');
      }
      // else if (txt.match(/^\s[a-zA-Z0-9][\sa-zA-Z0-9]+$/)) {  //entered txt & then entered space in 1st character
      //   event.target.value = txt.substring(1, txt.length);
      // } 
      else {
        event.target.value = txt.replace(/[^a-zA-Z0-9 ]/g, ''); //remove all special chars
      }
    } else {
      event.target.value = event.target.value.replace(/  +/g, ' '); //replace continuous multiple spaces with single space
    }
    return event.target.value;
  }

  validateStrWithRegExp(regExp, string) {
    return regExp.test(string) ? true : false;
  }

  // convertStrToObj(str) {
  //   let obj = str.replace(/'/g,'"')
  //   obj = JSON.parse(obj)
  //   return obj
  // }

  getDecimalToFixed(num, fixedTo) {
    return Number(num.toFixed(fixedTo));
  }

  isChatHostUser() {
    let chUser = sessionStorage.getItem('isChatHostUser');
    if (chUser === undefined || chUser === null) {
      return false;
    } else {
      return chUser === 'true' ? true : false;
    }
  }
  escapeHtml(text) {
    return text
      .replaceAll(/&amp;/g, "&").replaceAll("&lt;", "<").replaceAll("&gt;", ">");
  }
  allowDecimalInt(event, decimalLength = 2) {
    if (event.key === '-' || event.key === 'e') {
      event.preventDefault();
    } else {
      let value = event.srcElement.value;
      const dotIndex = value.indexOf('.');
      if (dotIndex > 0) {
        let decimalTxt = value.split('.')[1].substring(0, decimalLength);
        let result = value.split('.')[0] + '.' + decimalTxt;
        event.target.value = result;
      }
    }
  }
}